import { Button, Spin } from 'antd';
import { billingSelectors, workSpaceSelectors } from 'containers/App/selectors';
import { Formik } from 'formik';
import { Form, Input, SubmitButton } from 'formik-antd';
import { setLoadStep2 } from 'pages/BillingProcess/slices';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { t_medical_institution } from 'types';
import { getItemLinkInspec, updateSimple } from '../../BillingProcess/thunk';
import TableDataUser from './TableDataUser';
import { Wrapper } from './styles';

type Props = {
  nextStep: () => void;
  stepToPrevious: () => void;
};

type LocationState = {
  medicalDetail: t_medical_institution;
};

type InitialValues = {
  name_user: string;
  simple_inspection_remark: string;
  position?: number;
};

const BillingFourStep: FC<Props> = ({ nextStep, stepToPrevious }) => {
  const dispatch = useDispatch();
  const location = useLocation<LocationState>();
  const { itemInvoice, itemInspecD7, loadStep2 } = useSelector(billingSelectors);
  const { statusBill } = useSelector(workSpaceSelectors);
  const [submit, setSubmit] = useState<any>([]);

  useEffect(() => {
    dispatch(setLoadStep2(true));
    dispatch(
      getItemLinkInspec({
        invoice_id: itemInvoice?.invoice_id,
      }),
    );
  }, [dispatch, itemInvoice?.invoice_id]);

  const handleSubmit = (value: InitialValues, form: any) => {
    form.setSubmitting(false);
    const newData = {
      name: value.name_user,
      inspection_day: itemInvoice?.invoice_month,
      simple_inspection_remark: value.simple_inspection_remark,
      position: submit.length + 1,
    };
    setSubmit([...submit, newData]);
    form.resetForm();
  };

  const handleUpdate = async (statusBill: boolean | undefined) => {
    if (!statusBill) {
      const result: any = await dispatch(
        updateSimple({
          invoice_id: itemInvoice?.i_id,
          invoice_month: itemInvoice?.invoice_month,
          facility_id: location.state.medicalDetail.i_id,
          data_related: submit,
        }),
      );
      if (!result) return;
    }
    dispatch(
      getItemLinkInspec({
        invoice_id: itemInvoice?.invoice_id,
      }),
    );
    nextStep();
  };

  return (
    <Spin spinning={loadStep2} size="large">
      <Wrapper>
        <div className="section">
          <div className="extraLargeFont">4. 簡易検査明細作成</div>
          <div className="table-data-user">
            <TableDataUser
              dataDate={[...(itemInspecD7 ?? []), ...submit]}
              dataNew={submit}
              setSubmit={setSubmit}
              statusBill={statusBill && statusBill.value === itemInvoice?.invoice_month}
            />
          </div>
          {statusBill?.value === itemInvoice?.invoice_month ? null : (
            <div className="add-statement">
              <div className="standardBoldFont text">明細を追加</div>
              <div>
                <Formik
                  onSubmit={handleSubmit}
                  initialValues={initialValues}
                  render={() => (
                    <Form layout="inline" className="form-add">
                      <Form.Item name="name_user">
                        <p className=" label-select standardBoldFont">ご利用者名</p>
                        <Input size={'large'} style={{ width: 196 }} name="name_user" />
                      </Form.Item>
                      <Form.Item name="simple_inspection_remark">
                        <p className="label-select standardBoldFont">備考</p>
                        <Input style={{ width: 442 }} size="large" name="simple_inspection_remark" />
                      </Form.Item>
                      <SubmitButton size={'large'} className="btn-sbm btn-add">
                        追加
                      </SubmitButton>
                    </Form>
                  )}
                />
              </div>
            </div>
          )}
          <div className="confirm-step">
            <Button onClick={() => stepToPrevious()} className="btn-cancel-save">
              戻る
            </Button>
            <Button onClick={() => handleUpdate(statusBill?.value === itemInvoice?.invoice_month)} className="btn-save">
              {statusBill?.value === itemInvoice?.invoice_month ? '次へ' : '保存して次へ'}
            </Button>
          </div>
        </div>
      </Wrapper>
    </Spin>
  );
};

const initialValues: InitialValues = {
  name_user: '',
  simple_inspection_remark: '',
};

export default BillingFourStep;
